import { EntityRepository } from "~/utils";
import { AgentEffectCommands } from "../effect";
import { PlayerLeader } from "./PlayerLeader";
import { ResourceType } from "./ResourceType";

export const initPlayerLeaders = () => {
  const {
    payResource,
    cause,
    drawIntrigue,
    chooseFactionUpWhereBehind,
    solaris,
    spice,
    water,
    draw,
    reserveShopCardWithDiscount,
    landsraadPopularity,
    eyesEverywhere,
    spiceAdict,
    prescience,
    siegeConnections,
    ruthlessNegotiator,
    masterstroke,
    acquireTechTile,
    techNegociator,
    or,
    and,
    freighter,
    garnison,
    chooseFactionChange,
    freeCard,
    buySpaceWarp,
    dreadnoughtStrength,
    solarisBlessing,
    intrigueScry,
    trashOnRevealWhenPlayingNonFaction,
    planification,
  } = AgentEffectCommands;

  type PlayerLeaderDef = Omit<PlayerLeader, "id">;

  const baseLeaders: PlayerLeaderDef[] = [
    {
      name: "Baron Vladimir Harkonnen",
      signetRing: cause(
        payResource({ amount: 1, type: ResourceType.Solaris })
      ).effect(drawIntrigue),
      globalEffect: masterstroke,
    },
    {
      name: "Duke Leto Atreidis",
      signetRing: cause(
        payResource({ amount: 1, type: ResourceType.Spice })
      ).effect(chooseFactionUpWhereBehind),
      globalEffect: landsraadPopularity,
    },
    {
      name: "Helena  Richese",
      signetRing: reserveShopCardWithDiscount(1),
      globalEffect: eyesEverywhere,
    },
    {
      name: "Count Ilban Richese",
      signetRing: solaris(1),
      globalEffect: ruthlessNegotiator,
    },
    {
      name: "Countess Ariana Thorvald",
      signetRing: water(1),
      globalEffect: spiceAdict,
    },
    {
      name: "Paul Atreides",
      signetRing: draw,
      globalEffect: prescience,
    },
    {
      name: "Earl Memnon Thorvald",
      signetRing: spice(1),
      globalEffect: siegeConnections,
    },
  ];

  const ixLeaders: PlayerLeaderDef[] = [
    {
      name: "Prince Rhombur Vernius",
      signetRing: or([techNegociator, acquireTechTile({})]),
      globalEffect: dreadnoughtStrength,
    },
    {
      name: "Viscount Hudro Moritani",
      signetRing: cause(
        payResource({ amount: 1, type: ResourceType.Spice })
      ).effect(freighter),
      globalEffect: intrigueScry({ lookCount: 2, drawCount: 1 }),
    },
    {
      name: "Princess Yuna Moritani",
      signetRing: cause(
        payResource({ amount: 7, type: ResourceType.Solaris })
      ).effect(and([chooseFactionChange(1), spice(1), garnison(1)])),
      globalEffect: solarisBlessing,
    },
    {
      name: "Archduke Armand Ecaz",
      signetRing: freeCard({ cardMaxCost: 3 }),
      globalEffect: trashOnRevealWhenPlayingNonFaction,
    },
    {
      name: "Ilesa Ecaz",
      signetRing: cause(
        payResource({ amount: 1, type: ResourceType.Solaris })
      ).effect(buySpaceWarp),
      globalEffect: planification,
    },
    // TODO complicated
    // {
    //   name: "Tessia Vernius",
    //   signetRing: cause(chooseFactionChange(-1)).effect(), // +1 influence on faction with snooper token
    //   globalEffect: null, //
    // }
  ];

  playerLeaderRepository.addAll(
    baseLeaders.map((props) => ({ ...props, id: props.name }))
  );
  playerLeaderRepository.addAll(
    ixLeaders.map((props) => ({ ...props, id: props.name, extension: "Ix" }))
  );
};

export const playerLeaderRepository = EntityRepository.empty<PlayerLeader>();
